export const AUTH_PATHS = {
  LOGIN: '/login',
  LOGIN_SMS: '/login-sms',
  LOGOUT: '/logout',
  REGISTER: '/register',
  VERIFY: '/verify',
  FORGOT_PASSWORD: '/forgot-password',
  SETUP_NEW_PASSWORD: '/setup-newpassword',
  SETUP_USER_DETAILS: '/setup-user-details',
  MFA: '/mfa',
  MFA_SETUP_TOTP: '/mfa-setup-totp',
  MFA_SETUP_PHONE: '/mfa-setup-phone',
  ACCOUNT_RECOVERY: '/account-recovery',
} as const;

export const UNAUTHORIZED_PATHS = [
  AUTH_PATHS.LOGIN,
  AUTH_PATHS.LOGIN_SMS,
  AUTH_PATHS.REGISTER,
  AUTH_PATHS.VERIFY,
  AUTH_PATHS.FORGOT_PASSWORD,
  AUTH_PATHS.SETUP_NEW_PASSWORD,
  AUTH_PATHS.SETUP_USER_DETAILS,
  AUTH_PATHS.MFA,
  AUTH_PATHS.MFA_SETUP_TOTP,
  AUTH_PATHS.MFA_SETUP_PHONE,
  AUTH_PATHS.ACCOUNT_RECOVERY,
] as const;

/** Cognito user attribute key used to store/verify the phone number for SMS-based MFA. */
export const PHONE_NUMBER_ATTRIBUTE_KEY = 'phone_number' as const;

export const DEV_PHONE_VERIFICATION_CODE = '000000';
